import { useComponentLabels } from '@cguard/i18n';
import type { BrandedCameraSummary } from '@cguard/api-client/hooks/cameras';

export type CameraStatus = BrandedCameraSummary['status'];

/**
 * One wording for a camera's reported status across the rail, viewer,
 * analytics and counts: the shared camera-tile labels.
 */
export function useCameraStatusLabel(): (status: CameraStatus) => string {
  const { camera } = useComponentLabels();
  return (status) => {
    switch (status) {
      case 'live':
        return camera.live;
      case 'connecting':
        return camera.connecting;
      default:
        return camera.offline;
    }
  };
}
